module.exports = __webpack_public_path__ + "static/media/lights-holiday.da32b4d1.svg";